import axios from "axios";

export let Global = {
  appId: "Client",
  appTitle: "Innovair Solutions",
  appVersion: undefined,
  appStage: "",
  portApi: "2531",
  externalUrl: process.env.NODE_ENV === "production" ? "https://localhost:2530" : "https://localhost:2530",
  apiToken: "innovairsolutions_token",
  apiTokenAI: "innovairsolutions_tokenAI",
  language: "innovairsolutions_language",
  desktopWidth: "700px",
  axiosInterceptor: axios.interceptors.request.use((config) =>
  {
    config.headers['Expires'] = '-1';
    config.headers['Cache-Control'] = "no-cache,no-store,must-revalidate,max-age=-1,private";
    config.headers['Pragma'] = "no-cache";
    return config;
  }) 
};

export default Global;